import React from 'react';
import './App.css';
import Interface from './Interface';
import Routing from './Routing';

function App() {

  return (
    <Routing />
  );
}

export default App;
